<style lang="scss"></style>
<template>
  <div :class="$vuetify.breakpoint.mdAndUp ? 'px-12 my-12' : ''">
    <!--      mobile filter header-->
    <!--    <v-row class="hidden-md-and-up" style="margin:0;">-->
    <!--      <v-col cols="12" class="mobile-header text-center">-->
    <!--        {{ $t(`label.mobileHeader_Promotion`) }}-->
    <!--      </v-col>-->
    <!--    </v-row>-->

    <v-card class="hidden-md-and-up">
      <v-row justify="space-around" no-gutters>
        <v-col cols="12">
          <v-menu bottom :offset-y="true">
            <template v-slot:activator="{ on, attrs }">
              <v-card class="mobile-menu-card-wrapper">
                <v-btn v-bind="attrs" v-on="on" block class="mobile-category-menuBtn">
                  {{ selectedPromoCategory }}
                  <v-icon right large>mdi-menu-down</v-icon>
                </v-btn>
              </v-card>
            </template>
            <v-list>
              <v-list-item @click="getCmsBonus(0)">
                {{ $t(`label.all`) }}
              </v-list-item>
              <v-list-item v-for="bonusCategory in translatedBonusCategories" :key="bonusCategory.id" @click="getCmsBonus(bonusCategory.id, bonusCategory.name)">
                {{ bonusCategory.name }}
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-card>

    <!--      desktop filter header-->
    <v-card class="bonus-category-menu justify-space-around hidden-sm-and-down mb-2" style="box-shadow: none;">
      <v-row class="promotion-menu px-2" no-gutters>
        <v-btn
          @click="getCmsBonus(0)"
          class="my-2 px-3 py-2 page-promotion-button"
          height="auto"
          text
          :ripple="false"
          light
          depressed
          :class="{ 'conditional-styles': searchCriteria.bonusCategoryId == 0 }"
        >
          <v-row no-gutters>
            <v-col cols="12" class="px-0 text-center">
              <label class="bonus-category-menu-title px-2">{{ $t(`label.all`) }}</label>
            </v-col>
          </v-row>
        </v-btn>
        <v-btn
          v-for="bonusCategory in translatedBonusCategories"
          :key="bonusCategory.id"
          @click="getCmsBonus(bonusCategory.id)"
          class="my-2 px-3 py-2 page-promotion-button"
          :class="{ 'conditional-styles': searchCriteria.bonusCategoryId === bonusCategory.id }"
          height="auto"
          text
          :ripple="false"
          light
          depressed
        >
          <v-row no-gutters>
            <v-col cols="12" class="px-0 text-center">
              <label class="bonus-category-menu-title px-2">{{ bonusCategory.name }}</label>
            </v-col>
          </v-row>
        </v-btn>
      </v-row>
    </v-card>

    <!--    desktop n mobile share responsive layout-->
    <v-row class="d-flex mt-0 pt-0" justify="space-around" align="end">
      <v-col md="12" class="pt-0">
        <v-card class="promotion-card-container">
          <!--          <v-img class="white&#45;&#45;text align-end pa-0 hidden-sm-and-down" :aspect-ratio="$vuetify.breakpoint.smAndDown ? 360 / 88 : 1800 / 200" :src="`${mediaUrl}/game_banner/${promoType}.jpg`">-->
          <!--            <v-card-title class="promotion-banner-text font-weight-bold">-->
          <!--              <p class="ma-0">-->
          <!--                <span>-->
          <!--                  All Games Promotion-->
          <!--                </span>-->
          <!--              </p>-->
          <!--            </v-card-title>-->
          <!--          </v-img>-->
          <v-card-text>
            <v-row>
              <v-col v-for="(bonus, index) in bonusContent" :key="index" cols="12" md="6" lg="6" class="pa-3">
                <v-card class="promotion-box d-flex flex-column fill-height">
                  <!--                  <v-img class="promotion-image-box hidden-md-and-down" :src="`${bonus.mobile_img}`" :aspect-ratio="588 / 218" contain></v-img>-->
                  <v-img
                    class="promotion-image-box flex-grow-0"
                    :style="getBannerActionUrl(bonus) ? 'cursor: pointer' : ''"
                    :src="`${bonus.mobile_img}`"
                    :aspect-ratio="588 / 218"
                    contain
                    @click="onBannerClick(bonus)"
                  ></v-img>
                  <v-row no-gutters class="promotion-box-row flex-grow-1">
                    <v-col class="col-12">
                      <v-row v-if="$vuetify.breakpoint.xsOnly" class="promotion-desc-box" no-gutters justify="space-between">
                        <v-col class="promotion-tag-box">
                          <v-col v-for="bonus_tag in bonus.bonus_tag_list" :key="bonus_tag" cols="12" md="2" lg="2" class="promotion-tag-item">
                            <p class="mb-1 font-weight-bold promotion-tag-title">{{ bonus_tag }}</p>
                          </v-col>
                        </v-col>
                        <v-col cols="12">
                          <p class="mb-1 font-weight-bold promotion-desc-title">{{ bonus.title }}</p>
                          <p class="mb-1 d-block text-truncate">{{ bonus.desc }}</p>
                        </v-col>
                        <v-col cols="6" style="align-self: flex-end;padding-right:5px;" v-if="bonus.has_apply_button">
                          <v-btn height="auto" class="full-width font-weight-bold pa-1 buttonPrimary primary-button theme--light mobile-apply-btn" @click="onApplyBonusClick(bonus)">
                            {{ $t(`label.applyNow`) }}
                          </v-btn>
                        </v-col>
                        <v-col cols="6" style="align-self: flex-end;padding-left:5px;">
                          <v-btn @click="openPromotionTnc(bonus)" height="auto" dark class="primary-button pa-1 font-weight-bold mobile-detail-btn">{{ $t(`button.details`) }}</v-btn>
                        </v-col>
                      </v-row>
                      <v-row v-else class="promotion-desc-box" no-gutters justify="space-between">
                        <v-col class="promotion-tag-box">
                          <v-col v-for="bonus_tag in bonus.bonus_tag_list" :key="bonus_tag" cols="12" md="2" lg="2" class="promotion-tag-item">
                            <p class="mb-1 font-weight-bold promotion-tag-title">{{ bonus_tag }}</p>
                          </v-col>
                        </v-col>
                        <v-col cols="12">
                          <p class="mb-1 font-weight-bold promotion-desc-title">{{ bonus.title }}</p>
                          <p class="mb-1 d-block text-truncate">{{ bonus.desc }}</p>
                        </v-col>
                        <v-col cols="6" style="align-self: flex-end;padding-right:10px;" v-if="bonus.has_apply_button">
                          <v-btn class="full-width font-weight-bold pa-2 buttonPrimary primary-button theme--light mobile-apply-btn" @click="onApplyBonusClick(bonus)">
                            {{ $t(`label.applyNow`) }}
                          </v-btn>
                        </v-col>
                        <v-col cols="6" style="align-self: flex-end;padding-left:10px;">
                          <v-btn @click="openPromotionTnc(bonus)" dark class="primary-button pa-2 font-weight-bold  mobile-detail-btn">{{ $t(`button.details`) }}</v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <v-col class="text-center" v-if="bonusContent.length <= 0" cols="12">
                <p class="text-center text-capitalize mb-0">{{ $t(`label.noPromotionAvaliable`) }}</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <app-seo-content></app-seo-content>
    <app-dialog :dialogShow="promotionDialog.show" :max-width="1100" :title="promotionDialog.title" :closeAction="promotionDialog.dialogXButton">
      <v-container :class="[$vuetify.breakpoint.mdAndDown ? 'px-3' : 'px-5', $vuetify.breakpoint.smAndDown ? 'maxFrameHeight' : 'fill-height']">
        <div class="cms_bonus_content text-left" style="width:100%">
          <v-row no-gutters>
            <v-col cols="12" v-if="$vuetify.breakpoint.xsOnly">
              <v-btn
                v-if="isAllowApply"
                class="mb-4 full-width font-weight-bold pa-2 buttonPrimary primary-button theme--light apply-btn"
                style="width:100%"
                @click="onApplyBonusClick(selectedBonusObj)"
              >
                {{ $t(`label.applyNow`) }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="10" lg="10" sm="10">
              <p class="font-weight-bold mb-0">{{ $t(`label.promotionPeriod`) }}</p>
              <p>{{ promoData.start_time | utcToLocalTime }} - {{ promoData.end_time | utcToLocalTime }}</p>
            </v-col>
            <v-col cols="2" v-if="$vuetify.breakpoint.smAndUp && selectedBonusObj && selectedBonusObj.has_apply_button">
              <v-btn class="full-width font-weight-bold pa-2 buttonPrimary primary-button theme--light apply-btn" @click="onApplyBonusClick(selectedBonusObj)">{{ $t(`label.applyNow`) }}</v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" v-html="promoHtml" class="cms_bonus_content text-left"></v-col>
          </v-row>
        </div>
      </v-container>
    </app-dialog>
  </div>
</template>

<script>
import { DevicePlatform } from '@/constants/enums'
import { uiHelper, locale } from '@/util'
import { ROUTE_NAME } from '@/constants/route.constants'
import { BONUS_ANON_LIST, BONUS_LIST, BONUS_MANUAL_BONUS_LIST, BONUS_APPLY_BONUS } from '@/store/bonus.module'
import { CACHE_KEY } from '@/constants/constants'
import axios from 'axios'
import NavFilter from '@/assets/svg/navfilter.svg'
import { SHARED } from '../../constants/constants'
import { CMS_BONUS_ACTIVE } from '@/store/cms.module'
import { BONUS_RESET_APPLY_BONUS_RESPONSE_STORE } from '../../store/bonus.module'
import { errorCodeHelper } from '../../util'
import AppSeoContent from '@/components/layout/SEOContent.vue'

export default {
  name: 'promotion',
  props: {
    selectedType: {
      type: String,
      default: ''
    },
    cmsBonusCategoryId: {
      type: Number,
      default: 0
    }
  },
  components: {
    AppSeoContent,
    NavFilter
  },
  data: () => ({
    selectedPromoCategory: '',
    promoHtml: '',
    promoData: {},
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    storageGameProviderType: uiHelper.getLocalStorage(`${CACHE_KEY.GAME_PROVIDER_TYPE}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`),
    promotionFilterSheet: false,
    isAllowApply: false,
    currentLanguage: uiHelper.getLanguage(),
    selectedBonusId: '',
    selectedBonusObj: null,
    promotionFound: false,
    promotionTncUrl: '',
    promotionDialog: {
      show: false,
      title: locale.getMessage(`label.promotion`),
      dialogXButton: function() {}
    },
    selectedGameName: '',
    selectedCategory: 'all',
    gameProvider: '',
    gameName: '',
    promoType: '',
    filteredSlotGame: [],
    searchCriteria: {
      bonusCategoryId: 0,
      pageNumber: 1,
      pageSize: 20
    },
    manualPromotionList: [],
    promotionList: []
  }),
  computed: {
    translatedBonusCategories() {
      let categories = this.$store.state.cms.cmsBonusCategories
      // console.log(categories)
      return categories.map(c => {
        const localizedText = c.localization.filter(l => l.hasOwnProperty(this.currentLanguage))[0]
        if (localizedText) {
          return {
            name: localizedText[this.currentLanguage],
            id: c.id
          }
        }
        return {
          name: c.name,
          id: c.id
        }
      })
    },
    bonusApplyResult() {
      return this.$store.state.bonus.applyBonusResponse.complete
    },
    cmsBonusCategories() {
      return this.$store.state.cms.cmsBonusCategories
    },
    bonusContent() {
      return this.$store.state.cms.bonusContent
    },
    ProviderTypes() {
      return this.$store.state.game.ProviderTypes
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    bonusAnonList() {
      return this.$store.state.bonus.bonusAnonList
    },
    bonusList() {
      return this.$store.state.bonus.bonusList
    },
    manualBonusList() {
      return this.$store.state.bonus.manualBonusList
    }
  },
  watch: {
    async isLoggedIn() {
      if (this.isLoggedIn) {
        await this.getAvailableBonus()
      } else {
        await this.getAnonBonus()
      }
      this.populateDisplayBonusList()
    },
    selectedType() {
      this.searchCriteria.gameType = this.selectedType
    },
    ProviderTypes() {
      this.storageGameProviderType = this.$store.state.game.ProviderTypes
    },
    async bonusAnonList() {
      this.populateDisplayBonusList()
      return this.$store.state.bonus.bonusAnonList
    },
    async bonusList() {
      this.populateDisplayBonusList()
      return this.$store.state.bonus.bonusList
    },
    manualBonusList() {
      return this.$store.state.bonus.manualBonusList
    },
    bonusApplyResult() {
      if (this.$store.state.bonus.applyBonusResponse.complete) {
        this.closePromotionTncDialog()
        if (this.$store.state.bonus.applyBonusResponse.success) {
          this.$parent.openAlert(true, locale.getMessage(`message.bonusApplied`))
        } else {
          if (this.$store.state.bonus.applyBonusResponse.code == '5.16') {
            this.$parent.openAlert(true, locale.getMessage(`message.bonusApplied`))
          } else {
            this.$parent.openAlert(false, locale.getMessage(`message.promotionBonusFailed`))
          }
        }
        this.selectedBonusObj = null
        this.$store.dispatch(`${BONUS_RESET_APPLY_BONUS_RESPONSE_STORE}`)
        this.getCmsBonus(this.searchCriteria.bonusCategoryId)
      }
    }
  },
  async created() {
    console.log('promo created')
    this.getPreopenCondition()
    this.getCmsBonus(0)
    this.metaTag()
  },
  methods: {
    getBannerActionUrl(bonus) {
      // BO "Redirect to Action URL" toggle: bonuses.is_external_link + action_url (CMS returns the raw bonus row as bonus_details)
      let d = bonus.bonus_details
      return d && d.is_external_link && d.action_url ? d.action_url : null
    },
    onBannerClick(bonus) {
      let url = this.getBannerActionUrl(bonus)
      if (url) {
        window.open(url, '_blank')
      }
    },
    metaTag() {
      uiHelper.setTitle(`${locale.getMessage('meta.promotion_title')}`)
      uiHelper.setMetaTag('description', `${locale.getMessage('meta.promotion_description')}`)
    },
    getLadyImg(bonus) {
      let items = ['/static/image/promotion/whiteDress.png', '/static/image/promotion/blackDress.png']
      let random = Math.round(Math.random())
      return items[random]
    },
    getPromotTypeBgCss() {
      let items = ['red-bg', 'green-bg', 'blue-bg', 'purple-bg']
      let random = Math.ceil(Math.random() * 4)
      return items[random - 1]
    },
    populateDisplayBonusList() {
      this.promotionList = []
      if (this.isLoggedIn) {
        this.bonusList.forEach(bonus => {
          this.promotionList.push(bonus)
        })

        this.promotionList.sort(function(x, y) {
          if (y.endDate > x.endDate) return -1
          if (x.endDate < y.endDate) return 1
        })

        this.promotionList.sort(function(x, y) {
          if (x.isPin > y.isPin) {
            return -1
          } else if (x.isPin == y.isPin) {
            return x.isPin
          } else {
            return 1
          }
        })

        this.manualBonusList.forEach(bonus => {
          this.promotionList.push(bonus)
        })
        this.promotionList.sort(function(x, y) {
          if (y.endDate > x.endDate) return -1
          if (x.endDate < y.endDate) return 1
        })

        this.promotionList.sort(function(x, y) {
          if (x.isPin > y.isPin) {
            return -1
          } else if (x.isPin == y.isPin) {
            return x.isPin
          } else {
            return 1
          }
        })
      } else {
        this.bonusAnonList.forEach(bonus => {
          this.promotionList.push(bonus)
        })

        this.promotionList.sort(function(x, y) {
          if (y.endDate > x.endDate) return -1
          if (x.endDate < y.endDate) return 1
        })

        this.promotionList.sort(function(x, y) {
          if (x.isPin > y.isPin) {
            return -1
          } else if (x.isPin == y.isPin) {
            return x.isPin
          } else {
            return 1
          }
        })

        this.manualBonusList.forEach(bonus => {
          this.promotionList.push(bonus)
        })
        this.promotionList.sort(function(x, y) {
          if (y.endDate > x.endDate) return -1
          if (x.endDate < y.endDate) return 1
        })

        this.promotionList.sort(function(x, y) {
          if (x.isPin > y.isPin) {
            return -1
          } else if (x.isPin == y.isPin) {
            return x.isPin
          } else {
            return 1
          }
        })
      }
    },
    getPreopenCondition() {
      let bonusId = this.$route.params.bonusId

      if (bonusId != null && bonusId != undefined) {
        this.openPromotionTnc(bonusId)
      }
    },
    selectFilterType(filterType) {
      this.$emit('updateFilterType', filterType)
      this.promotionFilterSheet = false
    },
    async getManualPromotion() {
      await this.$store.dispatch(`${BONUS_MANUAL_BONUS_LIST}`)
    },
    getBonusTitle(bonusLocale) {
      if (bonusLocale.find(x => x.language == this.currentLanguage) != null && bonusLocale.find(x => x.language == this.currentLanguage) != undefined) {
        return bonusLocale.find(x => x.language == this.currentLanguage).title
      } else if (bonusLocale.find(x => x.language == 'en') != null && bonusLocale.find(x => x.language == 'en') != undefined) {
        return bonusLocale.find(x => x.language == 'en').title
      } else {
        return bonusLocale[0].title
      }
    },
    getBonusDesc(bonusLocale) {
      if (bonusLocale.find(x => x.language == this.currentLanguage) != null && bonusLocale.find(x => x.language == this.currentLanguage) != undefined) {
        return bonusLocale.find(x => x.language == this.currentLanguage).desc
      } else if (bonusLocale.find(x => x.language == 'en') != null && bonusLocale.find(x => x.language == 'en') != undefined) {
        return bonusLocale.find(x => x.language == 'en').desc
      } else {
        return bonusLocale[0].desc
      }
    },
    async getPromotionBonus() {
      if (this.isLoggedIn) {
        await this.getAvailableBonus()
      } else {
        await this.getAnonBonus()
      }
      await this.getManualPromotion()
      this.populateDisplayBonusList()
    },
    getCmsBonus(categoryId, translatedName) {
      this.selectedPromoCategory = categoryId == 0 ? locale.getMessage('label.all') : translatedName
      this.searchCriteria.bonusCategoryId = categoryId
      let obj = {
        language: uiHelper.getLanguage(),
        cmsBonusCategoryId: categoryId,
        currency: uiHelper.getCurrency()
      }
      this.$store.dispatch(`${CMS_BONUS_ACTIVE}`, { obj })
      let type = 'cricket'
      switch (this.searchCriteria.bonusCategoryId) {
        case 8:
          type = 'sb'
          break
        case 9:
          type = 'ld'
          break
        case 10:
          type = 'rng'
          break
        case 11:
          type = 'table'
          break
        case 12:
          type = 'lottery'
          break
        case 13:
          type = 'vip'
          break
        default:
          break
      }
      this.promoType = type
    },
    getAvailableBonus() {
      this.$store.dispatch(`${BONUS_LIST}`)
    },
    getAnonBonus() {
      this.$store.dispatch(`${BONUS_ANON_LIST}`)
    },
    getPromotionTncFile(id, content) {
      try {
        this.$ga.event('Bonus', `View Bonus`, `Bonus ID - ${id}`)
      } catch (err) {
        console.log(err)
      }
      let timestamp = new Date().getTime()
      let fileUrl = `${`${this.mediaUrl}/html/promotion/${this.currentLanguage}/${id}.html?v=${timestamp}`}`
      let promotionNotFoundUrl = `${process.env.BASE_URL}${`static/html/promotion/${this.currentLanguage}/non-found.html`}`
      this.promotionDialog.dialogXButton = this.closePromotionTncDialog

      let language = uiHelper.getLanguage()
      axios({
        method: 'GET',
        url: content,
        responseType: 'json'
      })
        .then(response => {
          if (response.status == 200) {
            this.promoHtml = response.data['tnc'].find(x => x.language == language)['content'].replace(/&nbsp;/g, ' ')
            this.promoData = {
              start_time: response.data.start_time,
              end_time: response.data.end_time
            }
            this.promotionDialog.show = true
          }
        })
        .catch(() => {
          this.promotionTncUrl = promotionNotFoundUrl
          this.promotionDialog.show = true
          console.log(`Promotion ID : ${id} `)
        })
    },
    onApplyBonusClick(bonus) {
      if (!this.isLoggedIn) {
        this.promptLogin()
        return
      }
      this.applyBonus(bonus)
    },
    applyBonus(bonus) {
      this.selectedBonusObj = bonus
      if (this.selectedBonusObj.redirect_to_deposit) {
        this.applyInDepositPage()
        return
      } else {
        this.onConfirmApplyOk()
        return
      }
      //this.openPromotionTnc(bonus)
    },
    applyInDepositPage() {
      let selectedBonusId = this.selectedBonusObj.bonus_id
      if (uiHelper.getPlatform() == DevicePlatform.MOBILE) {
        let routeData = this.$router.resolve({
          name: ROUTE_NAME.DEPOSIT,
          params: {
            bonusId: selectedBonusId
          }
        })
        window.open(routeData.href)
      } else {
        this.$router.push({
          name: ROUTE_NAME.DEPOSIT,
          params: {
            bonusId: selectedBonusId
          }
        })
      }
    },
    promptLogin() {
      this.$parent.openLoginDialog()
    },
    openPromotionTnc(bonus) {
      if (bonus != null) {
        this.selectedBonusObj = bonus
        this.isAllowApply = bonus != null
        this.getPromotionTncFile(bonus.id, bonus.content)
      }
    },
    closePromotionTncDialog() {
      this.promotionTncUrl = ''
      this.promotionDialog.show = false
      this.selectedBonusObj = null
    },
    onConfirmApplyOk() {
      const applyBonusObj = {
        bonusId: this.selectedBonusObj.bonus_id
      }
      this.$store.dispatch(`${BONUS_APPLY_BONUS}`, { applyBonusObj })
    },
    confirmationDialog() {
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.Confirmation`)
      dialog.message.push(locale.getMessage(`label.confirmApplyPromotion`))
      dialog.button.push({
        title: locale.getMessage(`label.ok`),
        action: () => this.onConfirmApplyOk()
      })
      dialog.button.push({
        title: locale.getMessage(`button.cancel`),
        action: () => this.closePageDialog()
      })
      this.openPageDialog(dialog)
    },
    initializePageDialogProperty() {
      let initPageDialog = {
        title: locale.getMessage(`label.system`),
        dialogXButton: this.closePageDialog,
        messageTitle: '',
        message: [],
        button: []
      }
      return initPageDialog
    },
    openPageDialog(dialog) {
      this.$eventHub.$emit('open-page-dialog', dialog)
    },
    closePageDialog() {
      this.$eventHub.$emit('close-page-dialog', true)
    }
  }
}
</script>

<style lang="scss">
.page-promotion-button {
  text-transform: capitalize !important;
  border-radius: 20px;

  label {
    cursor: pointer;
  }

  &:hover {
    background-color: #435131 !important;
    color: #FFFFFF !important;
    border-radius: 20px;
  }
}
.conditional-styles {
  font-weight: bold;
  background-color: #435131 !important;
  color: #FFFFFF !important;
  border-radius: 20px;
}
.promotion-menu {
  margin-left: 15px !important;
  gap: 10px;
}
.promotion-box {
  flex-direction: row;
}
.mobile-detail-btn {
  width: 100% !important;
  background-color: var(--v-newMobileSecondary-base) !important;
  color: #000000 !important;
}
.mobile-apply-btn {
  width: 100% !important;
  background-color: var(--v-newMobilePrimary-base) !important;
  color: #ffffff !important;
}
.mobile-header {
  background-color: #000000;
  color: var(--v-newMobilePrimary-base) !important;
  margin-top: auto;
  margin-bottom: auto;
}
.mobile-category-menuBtn {
  justify-content: space-between;
  background-color: #f5f5f5;
}

.mobile-menu-card-wrapper {
  border-radius: 15px;
  margin: 15px 15px 10px 15px;
}

.bonus-alert-success {
  .v-icon {
    color: #25b34b;
  }
}

.bonus-alert-failed {
  .v-icon {
    color: #dc2d2d;
  }
}

.bonus-category-container {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  max-width: 100vw;
}

.bonus-category-menu {
  //max-height: 80px;
  border-radius: 20px !important;
  background-color: #f3f5f6 !important;

  .bonus-category-menu-title {
    font-size: 24px;
    text-transform: capitalize;

    &:hover {
      color: #FFFFFF;
    }
  }

  .bonus-category-menu-divider {
    border: 2px solid #fddd04;
  }
}

.promotion-card-container {
  border-radius: 20px !important;

  .promotion-box {
    border-radius: 20px !important;

    .promotion-desc-box {
      background-color: #d9d9d9;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;
      color: #000000;
      height: 100%;
      font-size: 16px;
      padding: 24px 16px;

      .promotion-desc-title {
        font-size: 20px;
      }
    }

    .promotion-tag-box {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin-bottom: 5px;

      .promotion-tag-item {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        padding: 3px 10px;
        margin: 0 10px 10px 0;
        border-radius: 10px;
        border: 1px solid #6f6f80;
        width: fit-content;
        max-width: 100%;
        white-space: nowrap;
      }

      .promotion-tag-title {
        font-size: 12px;
      }
    }
  }
}

.cms_bonus_content {
  font-family: 'Heebo-Medium';
  text-align: left;
  padding-bottom: 24px;
  .apply-btn {
    color: #ffffff;
  }
}

.cms_bonus_content table {
  width: 100%;
  text-align: center;
  border-collapse: collapse;
}

.promotion-title {
  font-weight: 700;
  text-align: center;
  margin-bottom: 0;
  font-size: 20px;
  margin-top: 0;
}

.promotion-content {
  margin-bottom: 0;
  font-size: 16px;
  margin-top: 0;
}

table {
  width: 100%;
  text-align: center;
  border-collapse: collapse;
}

table,
th,
td {
  border: 1px solid #fff;
}

table thead tr td {
  font-size: 16px;
}

table tbody tr th {
  background-color: #000000;
  color: #ffffff;
  font-size: 16px;
}

table td {
  padding: 5px;
}

.cms_bonus_content {
  max-height: 450px;

  table,
  th,
  td {
    border: 1px solid #000000;
  }

  table thead th {
    background-color: #000000;
    font-size: 16px;
    color: #ffffff;
  }

  table tbody tr th {
    font-size: 16px;
  }

  table td {
    padding: 5px;
  }
}

.maxFrameHeight {
  max-height: 100%;
}

.promotion-filter-display {
  padding: 10px 15px;
}

.promotion-filter-display-text {
  font-size: 14px;
  margin-bottom: 0 !important;
}

.promotion-filter-button {
  background: linear-gradient(180deg, #273270 0%, #1c244f 100%);
  border-radius: 5px;
  width: 90px !important;
  font-weight: bold;
  min-width: 90px !important;
  padding: 5px 0px !important;

  .v-icon {
    font-size: 28px;
    padding: 0px;
  }
}

@media (max-width: 1024px) {
  .bonus-category-menu {
    border-radius: 20px !important;

    .bonus-category-menu-title {
      font-size: 20px;
      text-transform: capitalize;

      &:hover {
        color: #FFFFFF;
      }
    }

    .bonus-category-menu-divider {
      border: 2px solid #fddd04;
    }
  }
  //.promotion-card-container {
  //  border-radius: 20px !important;
  //
  //  .promotion-box {
  //    border-radius: 20px !important;
  //
  //    .promotion-desc-box {
  //      background-color: #d9d9d9 !important;
  //      color: #000000;
  //      height: 100%;
  //      font-size: 16px;
  //      padding: 15px 10px;
  //
  //      .promotion-desc-title {
  //        font-size: 20px;
  //      }
  //    }
  //  }
  //}
}

@media (max-width: 959px) {
  .promotion-box {
    flex-direction: column !important;
  }
  .promotion-desc-box {
    background-color: #333 !important;
    color: white !important;
    .mobile-detail-btn {
      width: 100% !important;
      background-color: var(--v-newMobileSecondary-base) !important;
      color: #000000 !important;
    }
    .mobile-apply-btn {
      width: 100% !important;
      background-color: var(--v-newMobilePrimary-base) !important;
      color: #ffffff !important;
    }
  }

  .bonus-category-menu {
    border-radius: unset !important;

    .bonus-category-menu-title {
      font-size: 16px;
      text-transform: capitalize;

      &:hover {
        color: #FFFFFF;
      }
    }

    .bonus-category-menu-divider {
      border: 2px solid #fddd04;
    }
  }
  .promotion-card-container {
    border-radius: unset !important;

    .promotion-box {
      border-radius: 20px !important;

      .promotion-image-box {
        border-top-left-radius: unset !important;
        border-bottom-left-radius: unset !important;
      }

      .promotion-desc-box {
        background-color: #d9d9d9;
        border-top-right-radius: unset !important;
        border-bottom-right-radius: unset !important;
        height: 100%;
        font-size: 16px;
        padding: 15px 10px;

        .promotion-desc-title {
          font-size: 20px;
        }
      }
    }
  }
}

@media (max-width: 425px) {
  .cms_bonus_content {
    font-size: 12px !important;
  }
  .bonus-category-menu {
    border-radius: 20px !important;

    .bonus-category-menu-title {
      font-size: 12px;
      text-transform: capitalize;

      &:hover {
        color: #FFFFFF;
      }
    }

    .bonus-category-menu-divider {
      border: 2px solid #fddd04;
    }
  }

  .promotion-card-container {
    border-radius: unset !important;

    .promotion-box {
      border-radius: 20px !important;

      .promotion-desc-box {
        background-color: #d9d9d9;
        border-top-right-radius: 0px !important;
        border-bottom-right-radius: 0px !important;
        height: 100%;
        font-size: 12px;
        line-height: 1rem;
        padding: 10px 5px;

        .promotion-desc-title {
          font-size: 15px;
          line-height: 1rem;
        }

        .v-btn.primary-button {
          width: 100% !important;
          height: fit-content !important;
          font-size: 11px !important;
          min-width: 50px !important;
        }
      }
    }
  }
}

@media (max-width: 959px) {
  .promotion-card-container {
    .promotion-box {
      .promotion-tag-box {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 5px;
        gap: 2px;

        .promotion-tag-item {
          width: fit-content;
          max-width: 18%;
          font-size: 12px;
        }

        .promotion-tag-title {
          font-size: 12px;
          line-height: 1;
        }
      }
    }
  }
}

@media (max-width: 635px) {
  .promotion-card-container {
    .promotion-box {
      .promotion-tag-box {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 5px;
        gap: 1px;

        .promotion-tag-item {
          width: fit-content;
          max-width: 22%;
          font-size: 12px;
        }

        .promotion-tag-title {
          font-size: 12px;
          line-height: 1;
        }
      }
    }
  }
}

@media (max-width: 425px) {
  .promotion-card-container {
    .promotion-box {
      .promotion-tag-box {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 5px;
        gap: 1px;

        .promotion-tag-item {
          width: fit-content;
          max-width: 21%;
          font-size: 6px;
        }

        .promotion-tag-title {
          font-size: 6px;
          line-height: 1;
        }
      }
    }
  }
}
</style>
